package com.nonopn.skydome.common.app.pages.sharing

import kotlinx.browser.window

actual class ShareManager {
    actual fun shareText(title: String, text: String) {
        try {
            @Suppress("UNCHECKED_CAST")
            if (js("typeof navigator.share === 'function'") as Boolean) {
                js("navigator.share({title: title, text: text})")
            } else {
                val mailUri =
                    "mailto:?subject=${title.encodeURIComponent()}&body=${text.encodeURIComponent()}"
                window.open(mailUri, "_self")
            }
        } catch (_: Exception) {
            // Silent fallback
        }
    }

    actual fun sharePdfUrl(title: String, url: String) {
        try {
            window.open(url, "_blank")
        } catch (_: Exception) {
            // Silent fallback
        }
    }

    actual fun shareHtmlAsPdf(title: String, html: String) {
        try {
            val target = window.open("", "_blank") ?: return
            target.document.open()
            target.document.write(html)
            target.document.close()
            target.print()
        } catch (_: Exception) {
            // Silent fallback
        }
    }

    private fun String.encodeURIComponent(): String =
        js("encodeURIComponent(this)") as String
}

actual fun createShareManager(): ShareManager = ShareManager()
